import {screens} from '~/design-system/hg/tokens'
import {type DefaultCinematicOverlayImageFragment} from '../../_generated/fragments.graphql'

export default function CinematicResponsiveImage(
  props: Partial<
    Pick<
      DefaultCinematicOverlayImageFragment,
      'desktopImage' | 'tabletImage' | 'mobileImage'
    >
  >
) {
  if (!props.desktopImage?.image?.responsiveImage) {
    return null
  }
  return (
    <picture>
      <source
        media={`(min-width: ${screens.lg})`}
        srcSet={props.desktopImage.image.responsiveImage.srcSet}
        sizes={props.desktopImage.image.responsiveImage.sizes}
      />
      {props.tabletImage?.image?.responsiveImage && (
        <source
          media={`(min-width: ${screens.sm})`}
          srcSet={props.tabletImage.image.responsiveImage.srcSet}
          sizes={props.tabletImage.image.responsiveImage.sizes}
        />
      )}
      <img
        src={
          props.mobileImage?.image?.responsiveImage?.src ||
          props.tabletImage?.image?.responsiveImage?.src ||
          props.desktopImage.image.responsiveImage.src
        }
        alt={
          props.mobileImage?.image?.responsiveImage?.alt ||
          props.tabletImage?.image?.responsiveImage?.alt ||
          props.desktopImage.image.responsiveImage?.alt ||
          ''
        }
        className="h-full object-cover"
        fetchPriority="high"
        loading="eager"
      />
    </picture>
  )
}

export function CinematicResponsiveMaskImage(
  props: Partial<Pick<DefaultCinematicOverlayImageFragment, 'desktopImage'>>
) {
  if (!props.desktopImage?.image?.responsiveImage) {
    return null
  }
  return (
    <picture>
      <source
        media={`(min-width: ${screens.lg})`}
        srcSet={props.desktopImage.image.responsiveImage.srcSet}
        sizes={props.desktopImage.image.responsiveImage.sizes}
      />
      {/* The mask effect is not used below desktop screens, so no we just use a transparent placeholder. This ensures that if we're not using the mask image, it won't be loaded and won't send additional network requests. */}
      <img
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        alt=""
        className="h-full object-cover"
        fetchPriority="high"
        loading="eager"
      />
    </picture>
  )
}
